import { forwardRef } from 'react';

export const SliderThumbIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="10.5" cy="10.5" r="10" fill="transparent" stroke="currentColor" />
        <rect x="7" y="6" width="1" height="8" rx="0.5" />
        <rect x="10" y="6" width="1" height="8" rx="0.5" />
        <rect x="13" y="6" width="1" height="8" rx="0.5" />
      </svg>
    );
  },
);
